import { AlertsRegister } from "@/features/oversight/monitoring";

export default function MonitoringAlertsPage() {
  return <AlertsRegister />;
}
